<template>
  <div :class="$style.sideNavNudge" :style="{ backgroundColor: bgColor }" data-qa-id="side-nav-nudge">
    <div :class="$style.nudgeHeader">
      <p :class="$style.nudgeTitle">{{ title }}</p>
      <button
        v-if="showClose"
        :class="$style.nudgeClose"
        data-qa-id="side-nav-nudge-close"
        @click="$emit('close')"
      >
        <MdIconClose size="sm" />
      </button>
    </div>
    <div :class="$style.nudgeBody">
      <slot />
    </div>
    <div v-if="$slots.actions" :class="$style.nudgeActions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
import { MdIconClose } from '@antiqua-dls/vue-components'

export default {
  name: 'SideNavNudge',

  components: { MdIconClose },

  props: {
    title: {
      type: String,
      required: true
    },
    showClose: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: '#f9fafb'
    }
  },

  emits: ['close']
}
</script>

<style lang="scss" module>
@import 'mpl-css/lib/assets/global/variables/fonts';

.sideNavNudge {
  border: 1px solid var(--md-color--spirits--300);
  border-radius: var(--md-border-radius--md);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-wrap: wrap;
  overflow-wrap: break-word;

  @media (max-width: 1279px) {
    display: none;
  }
}

.nudgeHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.nudgeTitle {
  margin: 0;
  font-family: $mt-medium;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.32px;
  color: var(--md-color--absolutes--black);
}

.nudgeClose {
  flex-shrink: 0;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--md-color--spirits--700);
}

.nudgeBody {
  font-family: $mt-regular;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: var(--md-color--spirits--700);

  p {
    margin: 0;

    & + p {
      margin-top: 16px;
    }
  }

  a {
    color: var(--md-color--blue-duck--500);
    text-decoration: none;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}

.nudgeActions {
  display: flex;
  flex-direction: column;
  gap: 8px;

  md-button::part(md-button) {
    width: 100%;
    justify-content: center;
  }
}
</style>
